
<template lang="pug">
q-page.fit
  .absolute-full.column

    //- ツールバー
    .col-auto
      .flex.justify-between.q-ma-xs
        .flex.items-center

          //- ユーザーの追加
          q-btn.q-mx-xs(
            flat
            @click="detailShow()"
          ) 追加

    //- グリッド
    .col.grid
      .grid__table(
        v-show="showGrid"
        ref="table"
        :style="gridTableStyle"
        @mousedown.left.stop="onMouseDownLeft"
      )
        .grid__thead

          //- 列ヘッダ
          .grid__column-header-area(@contextmenu.prevent)
            grid-columns(
              :grid="grid"
              :cols="cols"
              :getText="col => col"
            )

        //- セル
        .grid__cell-area(
          @dblclick="onCellDoubleClick"
          @mousedown.left.stop="onCellMouseDownLeft"
        )
          .grid__cell-cursor(:style="[gridCellCursorStyle, {left: 0, width: grid.cellW * 3 + 'px'}]")
          //- ContextMenu2をつけるとこのdiv無しでは.grid__tr以下がが消えてしまう。QContextMenuが破壊している？
          div
            .grid__tr(v-for="row of rows")
              .grid__cell(:style="gridCellStyle") {{row.name}}
              .grid__cell(:style="gridCellStyle") {{row.username}}
              .grid__cell(:style="gridCellStyle") {{getRoleLabel(row)}}

          ContextMenu2(@beforeShow="onCellContext")

  //- ユーザーの入力
  UsersDetail(
    ref="detail"
    :users="rows"
    @confirm="detailConfirm"
    @delete="detailDelete"
  )

</template>

<script>
import {mapAuto} from 'helpers/vuex-bind'
import RoleOption from 'models/RoleOption'

import UsersDetail from './UsersDetail'
import AxiosMixin from 'mixins/axios'
import GridMixin from 'mixins/GridMixin'

export default {
  components: {UsersDetail},
  mixins: [AxiosMixin, GridMixin],

  data() {
    return {
      grid: {
        cellW:    120,
        cellH:     25,
        headerW:    0,
        headerH:   25,
        paddingW:  20,
        paddingH:  20,
      },

      cols: Object.freeze(['名前', 'ログインID', '権限']),
      rows: [],
    }
  },

  computed: {
    ...mapAuto(['roleOptions']),
  },

  mounted() {
    this.refresh()
  },

  methods: {

    //-------------------------------------------------------------------------
    // マウスイベント

    onMouseDownLeft(e) {
      // ドラッグでグリッドをスクロールする
      this.beginDragScroll(e)
    },

    onCellMouseDownLeft(e) {
      // クリックでセルの選択を行う
      this.selectCell(e)
      // ドラッグでグリッドのスクロールを行う
      this.beginDragScroll(e)
    },

    onCellDoubleClick(e) {
      // ダブルクリックでセルの選択を行う
      this.selectCell(e)
      // ダブルクリックでユーザーの編集
      const {y} = this.getCellPosition(e)
      const user = this.rows[y]
      this.detailShow(user)
    },

    // cell領域のコンテキストメニュー
    onCellContext(e, options) {
      this.selectCell(e)
      options([{
        label: '編集', onClick: () => {
          const {y} = this.grid.cursor
          const user = this.rows[y]
          this.detailShow(user)
        },
      }])
    },

    //-------------------------------------------------------------------------
    // キーボードイベント

    onKeyDown(e) {
      // デフォルトのキーイベント処理 矢印,Tab,Enter,Escに対応
      if(this.processKeyDown(e)) {
        return
      }
    },

    onPressEnterBeginEdit() {
      // Enterキー押下でユーザーの編集
      const {y} = this.grid.cursor
      const user = this.rows[y]
      this.detailShow(user)
    },

    //-------------------------------------------------------------------------
    // ユーザー

    detailShow(data = {}) {
      this.$refs.detail.show(data)
    },

    async detailConfirm(id, data) {
      try {
        if(id) {
          await this.updateUser(id, data)
        }
        else {
          await this.createUser(data)
        }
        this.$refs.detail.hide()
      }
      catch(e) {this.$refs.detail.handler(e)}
    },

    async detailDelete(id) {
      try {
        await this.deleteUser(id)
        this.$refs.detail.hide()
      }
      catch(e) {this.$refs.detail.handler(e)}
    },

    //-------------------------------------------------------------------------
    // データ操作

    async refresh() {
      try {
        // 表示を一旦クリアする
        this.rows = []

        //
        const {data} = await this.axios.get('/api/users')
        this.rows = data

        //
        this.grid.cursor = {x: 0, y: 0}
      }
      catch(e) {this.$handler(e)}
    },

    async createUser(user) {
      const {data} = await this.axios.post('/api/users', user)
      this.rows.push(data)
    },

    async updateUser(id, user) {
      const index = this.rows.findIndex(row => row.id === id)
      if(index === -1) {
        this.refresh()
        return
      }

      const original = this.rows[index]

      // 変化があるプロパティを抽出する
      const diff = Object.entries(user).reduce((a, [k, v]) => ({...a, ...v !== original[k] ? {[k]: v} : {}}), {})

      if(diff.password === '') {
        delete diff.password
      }

      if(Object.keys(diff).length !== 0) {
        await this.axios.put('/api/users/' + id, diff)

        delete diff.password

        this.rows.splice(index, 1, {...original, ...diff})
      }
    },

    async deleteUser(id) {
      const index = this.rows.findIndex(row => row.id === id)
      if(index === -1) {
        this.refresh()
        return
      }

      await this.axios.delete('/api/users/' + id)
      this.rows.splice(index, 1)
    },

    // 権限表示
    getRoleLabel(row) {
      const key = RoleOption.key(row)
      const found = this.roleOptions.find(role => role.key === key)
      return found == null ? '不明' : found.label
    },
  },
}
</script>
